interface Props {
  page: number;
  totalPages: number;
  totalElements: number;
  pageSize: number;
  onChange: (page: number) => void;
}

/** Reusable pagination footer for tables. */
export function Pagination({
  page,
  totalPages,
  totalElements,
  pageSize,
  onChange,
}: Props) {
  if (totalPages <= 0) return null;
  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, totalElements);
  const btn =
    "inline-flex h-8 min-w-8 items-center justify-center rounded-md border border-border bg-background px-2 text-sm text-foreground transition-colors hover:bg-muted disabled:cursor-not-allowed disabled:opacity-40";
  return (
    <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
      <div className="text-sm text-muted-foreground">
        Hiển thị {start}–{end} trong {totalElements}
      </div>
      <div className="flex items-center gap-1">
        <button
          type="button"
          className={btn}
          disabled={page === 0}
          onClick={() => onChange(0)}
          aria-label="Trang đầu"
        >
          «
        </button>
        <button
          type="button"
          className={btn}
          disabled={page === 0}
          onClick={() => onChange(page - 1)}
          aria-label="Trang trước"
        >
          ‹
        </button>
        <button
          type="button"
          className={`${btn} border-primary bg-primary/10 font-medium text-primary`}
          disabled
          aria-current="page"
        >
          {page + 1} / {totalPages}
        </button>
        <button
          type="button"
          className={btn}
          disabled={page >= totalPages - 1}
          onClick={() => onChange(page + 1)}
          aria-label="Trang sau"
        >
          ›
        </button>
        <button
          type="button"
          className={btn}
          disabled={page >= totalPages - 1}
          onClick={() => onChange(totalPages - 1)}
          aria-label="Trang cuối"
        >
          »
        </button>
      </div>
    </div>
  );
}
